import React from 'react';
import { ChevronDownIcon, CheckIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
type AccordionItemProps = {
  title: string;
  icon: React.ReactNode;
  quote?: string;
  items?: string[];
  description?: string;
  imageUrl?: string;
  imageAlt?: string;
  visual?: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
  dark?: boolean;
  eyebrow?: string;
};
export function AccordionItem({
  title,
  icon,
  quote,
  items,
  description,
  imageUrl,
  imageAlt,
  visual,
  isOpen,
  onToggle,
  dark = false,
  eyebrow
}: AccordionItemProps) {
  return <article className={`overflow-hidden rounded-2xl border ${dark ? 'border-white/20 bg-white/10' : 'border-slate-200 bg-white'}`} data-id="element-1">
      <button type="button" className="flex w-full items-center justify-between gap-4 p-4 text-left" onClick={onToggle} aria-expanded={isOpen} data-id="element-2">
        <span className="flex min-w-0 items-center gap-3" data-id="element-3">
          <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${dark ? 'bg-[#FFC72C] text-[#1B3A6B]' : 'bg-[#F0F3F7] text-[#1B3A6B]'}`} data-id="element-4">
            {icon}
          </span>
          <span className="min-w-0" data-id="element-5">
            {eyebrow && <span className={`mb-0.5 block text-xs font-extrabold tracking-wide ${dark ? 'text-[#FFC72C]' : 'text-[#1B3A6B]'}`} data-id="element-6">
                {eyebrow}
              </span>}
            <span className={`block text-base font-extrabold leading-snug ${dark ? 'text-white' : 'text-[#1B3A6B]'}`} data-id="element-7">
              {title}
            </span>
          </span>
        </span>
        <ChevronDownIcon className={`h-5 w-5 shrink-0 transition-transform duration-300 ${dark ? 'text-white' : 'text-[#1B3A6B]'} ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-8" />
      </button>

      <AnimatePresence initial={false} data-id="element-9">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-10">
            <div className={`border-t px-4 pb-5 pt-4 ${dark ? 'border-white/15' : 'border-slate-100'}`} data-id="element-11">
              {quote && <p className={`mb-4 font-semibold leading-relaxed ${dark ? 'text-white' : 'text-[#1B3A6B]'}`} data-id="element-12">
                  “{quote}”
                </p>}
              {description && <p className={`mb-4 text-sm leading-relaxed ${dark ? 'text-slate-200' : 'text-[#4A5568]'}`} data-id="element-13">
                  {description}
                </p>}
              {items && <ul className={`mb-5 space-y-2 text-sm leading-relaxed ${dark ? 'text-slate-100' : 'text-[#4A5568]'}`} data-id="element-14">
                  {items.map(item => <li className="flex gap-2" key={item} data-id="element-15">
                      <CheckIcon className={`mt-0.5 h-4 w-4 shrink-0 ${dark ? 'text-[#FFC72C]' : 'text-[#1B3A6B]'}`} data-id="element-16" />
                      <span data-id="element-17">{item}</span>
                    </li>)}
                </ul>}
              {visual}
              {!visual && imageUrl && <img src={imageUrl} alt={imageAlt ?? ''} className="h-44 w-full rounded-xl border border-slate-200 object-cover object-top" data-id="element-18" />}
            </div>
          </motion.div>}
      </AnimatePresence>
    </article>;
}